import Vue from "vue";

export const getGroups = ({ commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get("groups")
      .then(call => {
        commit("SET_GROUPS", call.data);
        resolve(call.data);
      })
      .catch(() => reject());
  });
};

export const matchGroup = ({ rootState, commit }) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .get(
        `groups/${rootState.application.matchable}/match?productId=${rootState.pageParams.productId}&apiKey=${rootState.pageParams.apiKey}&amount=${rootState.pageParams.desiredQuantity}`
      )
      .then(call => {
        commit("SET_GROUP_MATCH", call.data);
        commit("users/SET_GROUP_MATCH_DATA", call.data, { root: true });
        resolve();
      })
      .catch(() => reject());
  });
};

export const sendMatchData = ({ rootState }, payload) => {
  return new Promise((resolve, reject) => {
    Vue.$axios
      .post(
        `groups/${rootState.application.matchable}/mail_csv/${payload.sku}`,
        payload.matchData
      )
      .then(call => {
        resolve(call);
      })
      .catch(() => reject());
  });
};
